interface PerspectiveCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
  accentColor: string;
}

export default function PerspectiveCard({
  title,
  description,
  icon,
  onClick,
  accentColor,
}: PerspectiveCardProps) {
  return (
    <div
      onClick={onClick}
      className="group cursor-pointer bg-ti-surface border border-ti-border rounded-xl p-8 flex flex-col items-center text-center gap-5 transition-all duration-300 hover:scale-[1.02]"
      style={{
        // Use CSS custom property so hover styles can reference the accent color
        '--accent': accentColor,
      } as React.CSSProperties}
      onMouseEnter={(e) => {
        const el = e.currentTarget;
        el.style.borderColor = accentColor;
        el.style.boxShadow = `0 0 24px ${accentColor}22, 0 0 48px ${accentColor}11`;
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget;
        el.style.borderColor = '';
        el.style.boxShadow = '';
      }}
    >
      {/* Icon */}
      <div
        className="w-16 h-16 flex items-center justify-center rounded-xl transition-colors duration-300"
        style={{ color: accentColor, backgroundColor: `${accentColor}15` }}
      >
        {icon}
      </div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-ti-text">{title}</h3>

      {/* Description */}
      <p className="text-ti-text-muted leading-relaxed">{description}</p>

      {/* Explore Button */}
      <button
        className="mt-auto px-6 py-2.5 rounded-lg font-medium text-white transition-all duration-300 hover:brightness-110 cursor-pointer"
        style={{ backgroundColor: accentColor }}
      >
        Explore
      </button>
    </div>
  );
}
